import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { SharedModule } from '../shared.module';

import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';

import { HeaderComponent } from "./header/header.component";
import { QuickViewComponent } from './quick-view/quick-view.component';
import { FooterComponent } from "./footer/footer.component";

import { ThemeConstantService } from '../services/theme-constant.service';
import { FullHeaderComponent } from './full-header/full-header.component';
import { VjHeaderComponent } from './vjtheme/vj-header/vj-header.component';
import { VjFooterComponent } from './vjtheme/vj-footer/vj-footer.component';
import { VjMainNavBarComponent } from './vjtheme/vj-main-nav-bar/vj-main-nav-bar.component';
import { VjProfileNavBarComponent } from './vjtheme/vj-profile-nav-bar/vj-profile-nav-bar.component';
import { FormsModule } from '@angular/forms';
import { VjBreadcrumbComponent } from './vjtheme/vj-breadcrumb/vj-breadcrumb.component';
import { VjHelpNavBarComponent } from './vjtheme/vj-help-nav-bar/vj-help-nav-bar.component';

const antdModule = [
    NzAvatarModule,
    NzBadgeModule,
    NzRadioModule,
    NzDropDownModule,
    NzListModule,
    NzDrawerModule,
    NzDividerModule,
    NzSwitchModule,
    NzInputModule,
    NzButtonModule
]

@NgModule({
    exports: [
        CommonModule,
        HeaderComponent,
        QuickViewComponent,
        FooterComponent,
        FullHeaderComponent,
        VjHeaderComponent,
        VjFooterComponent,
        VjMainNavBarComponent,
        VjProfileNavBarComponent,
        VjBreadcrumbComponent,
        VjHelpNavBarComponent
    ],
    imports: [
        RouterModule,
        CommonModule,
        SharedModule,
        FormsModule,
        ...antdModule
    ],
    declarations: [
        HeaderComponent,
        QuickViewComponent,
        FooterComponent,
        FullHeaderComponent,
        VjHeaderComponent,
        VjFooterComponent,
        VjMainNavBarComponent,
        VjProfileNavBarComponent,
        VjBreadcrumbComponent,
        VjHelpNavBarComponent
    ],
    providers: [ 
        ThemeConstantService
    ]
})

export class TemplateModule { }
